import useBackButton from '../hooks/useBackButton';

const BackButtonHandler = () => {
    useBackButton();
    return null;
};

export default BackButtonHandler;
